import serviceClient from '../../service-client/service-client';

const getMediaLibraryAsset = (source) => () =>
  serviceClient
    .get()
    .getMediaLibraryAssets({ source })
    .then((response) => {
      if (response.data.count === 1) {
        const [result] = response.data.results;

        return result;
      }

      return null;
    });

export default getMediaLibraryAsset;
